<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout class="justify-space-around mt-2 pb-2 pr-2 pl-0 mb-6" row>
      <MapContainer>
        <WorldMap_MPMC />
      </MapContainer>

      <v-flex v-show="!$store.state.app.big_map" class="mt-2" lg7 md12 sm12 xl6>
        <top-summary-results class="mb-2" />

        <div class="">
          <v-layout row>
            <v-flex class="xs12 sm12 lg12">
              <div class="body-2 font-weight-bold nav nav-tabs">
                <!-- /.tabrow -->
                <li class="">
                  <a class="disabled"
                    >Details ({{ $store.getters.selectionCounts.results.markets_count }}
                    target markets x
                    {{ $store.getters.selectionCounts.results.products_count }}
                    products)
                    <help-link help_id="15" style="float: right" />
                  </a>
                </li>
              </div>
            </v-flex>
          </v-layout>

          <div class="tab-content">
            <div class="tab-pane active white">
              <v-container fluid>
                <v-row>
                  <v-col sm="12">
                    <applied_filters_box class="mr-4 mb-0"></applied_filters_box>
                  </v-col>
                </v-row>

                <v-row class="justify-space-between mt-0 ml-0 mr-1 black--text" row>
                  <template
                    v-if="
                      $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                        .markets_count !== 0 &&
                        $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                          .combinations.products_count !== 0
                    "
                  >
                    <v-flex>
                      <products_filtered_box></products_filtered_box>
                    </v-flex>
                    <v-flex>
                      <countries_filtered_box class="mt-2"></countries_filtered_box>
                    </v-flex>
                  </template>
                </v-row>

                <v-layout
                  v-if="is_run_cube_valid"
                  class="justify-space-between mt-0 ml-2 mr-1 black--text"
                  row
                >
                  <v-flex sm12>
                    <v-layout v-if="cube['items'].length > 0" row>
                      <v-flex>
                        <v-card class="pt-2 mr-3 ml-4">
                          <v-tabs
                            v-model="country_tabs"
                            active-class="trade-blue"
                            background-color="tab_header_color"
                            slider-color="green"
                            dark
                            dense
                          >
                            <v-tab> Countries</v-tab>
                            <v-tab> Sub-Region</v-tab>
                            <v-tab> Main-Region</v-tab>
                            <v-tab-item>
                              <v-card flat>
                                <v-layout class="pa-2" row>
                                  <v-flex>
                                    <reo_table_markets
                                      cube="cube"
                                      table_id="country_cube"
                                    />
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-layout class="pa-2" row>
                                <v-flex>
                                  <reo_table_markets
                                    cube="cube_C_Region"
                                    table_id="C_Region_cube"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card flat>
                                <v-layout class="pa-2" row>
                                  <v-flex>
                                    <reo_table_markets
                                      cube="cube_Main_Region"
                                      table_id="Main_Region_cube"
                                    />
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </v-card>
                      </v-flex>
                    </v-layout>

                    <template v-else>
                      <div
                        v-if="
                          $store.state.tradeDSM.loading_indicator &&
                            current_report_to_run === 'MPMC'
                        "
                      >
                        <div class="ml-4 blink">Loading Countries REO table</div>
                        <v-skeleton-loader
                          class="mt-3 mb-4"
                          type="article, actions"
                        ></v-skeleton-loader>
                      </div>
                    </template>
                  </v-flex>
                  <v-flex sm12>
                    <reoCubeWrapper></reoCubeWrapper>
                  </v-flex>
                </v-layout>

                <v-layout v-if="!is_run_cube_valid">
                  <v-flex>
                    <reoFrontendTable></reoFrontendTable>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>

          <template
            v-if="
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                .markets_count === 0 &&
                $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                  .products_count === 0
            "
          >
            <p class="outline mt-12 text-h5 pa-4">
              There are no results for the current set of applied filters, product and
              market selections. More details about the current applied selections can be
              found in the 'Details' tab above. <br /><br />
              <v-btn
                @click="run_cube_clear_filters"
                class="red white--text"
                v-if="
                  $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                    .filter_in_progress === true &&
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                      .combinations === 0
                "
                >Reset Filters and Rerun
              </v-btn>
            </p>
          </template>
        </div>
      </v-flex>

      <v-layout v-if="is_run_cube_valid">
        <v-flex class="xs12 sm12 lg12 ml-5 mr-8 mb-9 mt-12">
          <reoFrontendTable></reoFrontendTable>
        </v-flex>
      </v-layout>
      ></v-layout
    >
  </div>
</template>
<script>
import TopSummaryResults from '@/components/trade-dsm-application/result-components/top-summary-results';
import WorldMap_MPMC from '@/components/trade-dsm-application/graphs/mpmc/world-map-mpmc';
import countries_filtered_box from '@/components/trade-dsm-application/results-pages/markets-filters-box';
import products_filtered_box from '@/components/trade-dsm-application/results-pages/products-filter-box';
import MapContainer from '@/components/trade-dsm-application/result-components/helpers/map-container';
import reo_table_markets from '@/components/trade-dsm-application/results-pages/tabs/reo_table_markets';
import applied_filters_box from '@/components/trade-dsm-application/results-pages/applied-filters-box';
import reoFrontendTable from '@/components/trade-dsm-application/result-components/reo_table/reo-frontend-table';
import reoCubeWrapper from '@/components/trade-dsm-application/result-components/reo_cube_wrapper/reo-cube-wrapper';
import helpLink from '@/components/application-level/help-system/help-link';
import {mapGetters} from 'vuex';

export default {
  name: 'tabmpmc',
  components: {
    TopSummaryResults,
    WorldMap_MPMC,
    countries_filtered_box,
    products_filtered_box,
    MapContainer,
    reo_table_markets,
    applied_filters_box,
    reoFrontendTable,
    reoCubeWrapper,
    helpLink,
  },
  props: {
    cube: {},
    cube_C_Region: {},
    cube_Main_Region: {},
    cube_Trade_Block: {},
    cubehs6code: {},
    cubehs4code: {},
    cubehs2code: {},
    cubesection: {},
    // display_advanced_filter_countries: {},
    // display_advanced_filter_products: {},
    // display_advanved_filters_applied: {},

    map_rerender_workarount: {},
  },
  computed: {
    ...mapGetters(['is_run_cube_valid']),
  },
  methods: {
    async run_cube_clear_filters() {
      // backup the current selection if any
      let product_backup = [];
      let market_backup = [];

      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 0
      ) {
        product_backup = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .selections.products.HS6_Code;
      } else {
        product_backup = [];
      }

      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 0
      ) {
        market_backup = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .selections.markets.C_Code;
      } else {
        market_backup = [];
      }

      // clear the filters to a state of no filters.
      await this.reset_filters('FILTERS');

      // add the selection back to the state
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = product_backup;

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = market_backup;

      // now update the cube again.
      await this.update_results_cube();
    },
  },
  data() {
    return {
      big_map: false,
      country_tabs: 0,
      product_tabs: 0,
    };
  },
};
</script>

<style scoped></style>
